<template>
  <Modal
    class="scoped"
    hide-close-button
    :title="title"
    v-bind="localModalProps"
  >
    <div :class="messageClass">
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="html"
        v-html="message"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div v-else>
        {{ message }}
      </div>
    </div>
    <template #buttons>
      <BaseButton
        v-if="!hideCancel"
        :aria-label="cancelLabel"
        flat
        :label="cancelLabel"
        new-design
        @click="cancel"
      />
      <BaseButton
        :aria-label="confirmLabel"
        color="primary"
        :label="confirmLabel"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "ConfirmModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    title: {
      type: String,
      default: () => getLocaleText("modals.confirm_modal.title"),
    },
    confirmLabel: {
      type: String,
      default: () => getLocaleText("global.confirm"),
    },
    cancelLabel: {
      type: String,
      default: () => getLocaleText("global.cancel"),
    },
    message: {
      type: String,
      default: "",
    },
    html: {
      type: Boolean,
    },
    messageClass: {
      type: String,
      default: "",
    },
    hideCancel: {
      type: Boolean,
    },
    offsetMenu: {
      type: Boolean,
    },
    buttonsClass: {
      type: String,
      default: null,
    },
    modalStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["confirm", "cancel"],
  computed: {
    localModalStyle() {
      return { width: this.$isDesktop ? "40%" : "100%", ...this.modalStyle };
    },
    localModalProps() {
      return {
        modalStyle: this.localModalStyle,
        offsetMenu: this.offsetMenu,
        ...(this.buttonsClass ? this.buttonsClass : {}),
      };
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.$modals.close("ConfirmModal");
    },
  },
};
</script>
